import { put } from '..';

const editAssetNote = (InstanceId: string, Note) => put(
  'assets/notes',
  { InstanceId, Note },
);

export default editAssetNote;
